<template>
  <div>
    <div class="form-container ou-donation-form teach-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Sponsorships & Tickets">
            <div>
        <div
          class="teach-styled styled-radio-container styled-radio-container--ou-donation row"
        >
          <div v-for="[amount, description] of amounts" :key="amount" class="amount-row">
            <input
              :id="`amount${amount}`"
              type="radio"
              class="amount"
              @click="(selectedAmount = amount)"
              :checked="(selectedAmount == amount)"
            />
            <FormLabel :for="`amount${amount}`">
              <div class="label__wrapper" v-html="description"></div>
            </FormLabel>
          </div>
          </div>
          </div>

      <p class="note">
        Leadership Circle Members attend free. If you are an existing 2023 Leadership Circle Member, please RSVP by contacting Davida Fried at  <a style="color: #00346b" href="mailto:friedd@teachcoalition.org">friedd@teachcoalition.org</a> or call/text <a style="color: #00346b" href="tel:617-913-8140">617-913-8140</a>.
      </p>
            <ErrorLabel field="amount" />
            <TransactionFee/>
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit/>
            </div>
          </FormSection>
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol :simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>   
            <div v-if="form.amount && Number(form.amount) && Number(form.amount) > 179">
            <FormRow>
            <FormLabel class="control-label"> Spouse's Name </FormLabel>
          </FormRow>
          <FormRow >
            <FormInput
              type="text"
              class="width-full"
              field="custom.coupleName"
            />
          </FormRow>   
            </div>  
            <FormRow inline>
              <FormCol field="custom.schoolName" width="half" :showLabel="false">
                <FormLabel class="control-label"> School Affiliation: </FormLabel>
                <FormInput
              type="text"
              class="width-full"
              field="custom.schoolName"
                />
              </FormCol>
            </FormRow>                   
            <FormRow>
              <FormLabel>
                <NewsletterSubscribe
                  text="Click here if you would like to receive email updates"
                />
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info" last>
            <div class="payment-info">
              <FormRow>
                <PaymentType check_text="Pay by Check" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Teach Coalition<br />
                      C/O Caleb Fischer<br />
                      40 Rector St, 4th Floor<br />
                      New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" class="teachpay" />
        </PaymentForm>
        <div class="footer-links">
          <div style="color: black; font-weight: 600; margin-bottom: 17px">
            If you are an existing 2023 Leadership Circle Member, <br />please RSVP by
            contacting Davida Fried at
            <a
              href="mailto:friedd@teachcoalition.org?subject=RSVP%20for%20Summer%20%26%20BBQ&amp;body=Hi%20Davida%2C%0A%0AI%20am%20an%20existing%202023%20Leadership%20Circle%20member%2C%20and%20will%20attend%20the%20Summer%20%26%20BBQ%20Event.%0A%0APlease%20sign%20me%20up."
              >friedd@teachcoalition.org</a
            > <br>or (617) 447-8847.
          </div>

        </div>
        <div class="footer-copyright">
          Teach Coalition, a project of the Orthodox Union, is a 501(c)(3), EIN:
          13-5623717.<br />
          All donations to Teach Coalition are tax-deductible to the full extent permitted
          by law.
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup(props) {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const ticketsQnt = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    const customQnt = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;
        customAmount.value = null;
        if (ticketsQnt.value > 0 && (selectedAmount === 180 || selectedAmount === 180)) {
          setValue("amount", "" + selectedAmount * ticketsQnt.value);
        } else {
          setValue("amount", "" + selectedAmount);
        }
      }
    });
    watch(customQnt, () => {
      customQnt.value = false;
      if (ticketsQnt) {
        setValue("amount", "" + selectedAmount.value * ticketsQnt.value);
        setValue("custom.ticketsQnt", ticketsQnt.value);
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
        //@ts-ignore
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    // setValue("amount", "100");
    // setValue("custom.ticketsQnt", "" + 1);
    // const ticketsQnt = ref();

    // watch(ticketsQnt, () => {
    //   if (ticketsQnt.value !== 'Not Attending') {
    //     setValue("amount", "" + 100 * ticketsQnt.value);
    //     setValue("custom.ticketsQnt", ticketsQnt.value);
    //   }else {
    //     setValue("amount", "100");
    //     setValue("custom.ticketsQnt", "Not Attending");
    //   }
    // });

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      ticketsQnt,
      clearOutSelectedValue,
      customSelected,
      customQnt,
      setValue,
      getValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.donate-intro {
  font-size: 18px;
  line-height: 26px;
  color: #00346b;
  p {
    margin-bottom: 10px;
  }
  a {
    color: #00346b;
    font-weight: 600;
  }
}

.form-container.ou-donation-form.teach-donation-form {
  max-width: 770px;
  box-shadow: none;
  padding: 10px 30px 62px;
  @media only screen and (min-width: 720px) {
    padding: 0px 50px 0px;
    margin: 0px auto;
  }
}
.teach-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {

  label {
    border: 1px solid #230b01;
    color: white;
    font-size: 15px;
    background: #230b01;
    &:hover {
      // background: #f7f7f7;
    }
  }
  input[type="radio"]:checked + label {
    background: #be9e5f;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #be9e5f;
    border-color: #be9e5f;
  }
  .label-description {
    font-size: 16px;
  }
  .label-amount {
    background: #be9e5f;
    color: white;
  }
  .radio-part {
    min-width: 23%;
    max-width: 23%;
  }
}

.teach-donation-form
  .frequency
  ::v-deep
  .styled-radio-container--ou-donation.styled-radio-container {
  .radio-part {
    min-width: 33%;
    max-width: 33%;
  }
}
.teach-donation-form .payment-info ::v-deep .styled-radio-container--ou-donation {
  .radio-part {
    min-width: 50%;
    max-width: 50%;
  }
}
.footer-links {
  text-align: center;
  font-size: 16px;
  margin: 50px auto 28px;
  line-height: 26px;
  color: #00346b;
  a {
    text-decoration: none;
  }
}
.footer-copyright {
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  color: #222;
  font-style: italic;
}

.payment {
  margin: 20px auto 20px;
  ::v-deep .ou-donation-btn {
    width: 300px;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
}
.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}

.tickets-num{
  label{
    display: flex;
    flex-flow: column;
    background: white;
    border: none;
  }

  select{
    max-width: 200px;
    margin-top: 6px;
  }
}

.styled-radio-container--ou-donation.styled-radio-container.teach-styled {
    margin: 0 0 5px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 2%;
    font-size: 17px;
    justify-content: flex-start;
    .amount-row {
    min-width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    width: 100%;

    @media only screen and (min-width: 720px) {
      min-width: 48% !important;
    max-width: 48% !important;
    }
    input[type=radio] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
    }
 label{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding: 12px 5px;
    font-weight: 500;
    background: #230b01 !important;
    color: #fff!important;
    display: flex!important;
    line-height: normal;
    border: 1px solid #ddd;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    height: 100%;
    overflow: hidden;
}
 ::v-deep .label__wrapper {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    grid-gap: 8px;
    gap: 8px;
    font-size: 17px;
  span {
    font-style: italic;
    font-size: 16px;
}
}
}

input[type=radio]:checked+label {
    background: #be9e5f!important;
}

}

::v-deep .styled-radio-container--ou-donation.styled-radio-container{
  justify-content: flex-start;
}

.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
</style>
